/**
 * ABaseMark
 */
export abstract class ABaseMark<MarkerType> {
  public name: string;

  public instance: MarkerType;

  /**
   * constructor
   *
   * @param {string} name
   * @param {MarkerType} instance
   */
  public constructor(name: string, instance: MarkerType) {
    this.name = name;
    this.instance = instance;
  }

  public abstract end(): void;
}
